module.exports = __webpack_public_path__ + "img/3.0161c966.jpg";